export const REPORT_TYPES: Record<string, { code: string; name: string; keywords: string[]; defaultTemplate?: string }> = {
  'demand-slip': {
    code: 'DEMAND_SLIP',
    name: 'Demand Slip',
    keywords: [
      '#SNO#',
      '#DATE#',
      '#STUDENTNAME#',
      '#FATHERNAME#',
      '#CLASS#',
      '#SECTION#',
      '#SESSION#',
      '#FEEHEAD#',
      '#FEEAMOUNT#',
      '#DUEDATE#',
      '#TOTAL#',
      '#INWORDS#',
    ],
    defaultTemplate: `
      <figure class="table">
        <table style="width:100%; border-collapse: collapse; border: 1px solid black;">
          <thead>
            <tr>
              <th colspan="2" style="text-align: center; border: 1px solid black; padding: 10px;">
                <h3>SCHOOL NAME</h3>
                <p>School Address, City</p>
                <h4>FEE DEMAND SLIP</h4>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid black; padding: 5px;"><strong>S.No:</strong> #SNO#</td>
              <td style="border: 1px solid black; padding: 5px;"><strong>Date:</strong> #DATE#</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; padding: 5px;"><strong>Student Name:</strong> #STUDENTNAME#</td>
              <td style="border: 1px solid black; padding: 5px;"><strong>Father Name:</strong> #FATHERNAME#</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; padding: 5px;"><strong>Class/Section:</strong> #CLASS# - #SECTION#</td>
              <td style="border: 1px solid black; padding: 5px;"><strong>Session:</strong> #SESSION#</td>
            </tr>
            <tr>
              <td colspan="2" style="border: 1px solid black; padding: 0;">
                <table style="width: 100%; border-collapse: collapse;">
                  <thead>
                    <tr style="background-color: #f0f0f0;">
                      <th style="border: 1px solid black; padding: 5px;">Fee Head</th>
                      <th style="border: 1px solid black; padding: 5px; text-align: right;">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- This row represents the repeatable fee structure -->
                    <tr>
                      <td style="border: 1px solid black; padding: 5px;">#FEEHEAD#</td>
                      <td style="border: 1px solid black; padding: 5px; text-align: right;">#FEEAMOUNT#</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr style="font-weight: bold;">
                      <td style="border: 1px solid black; padding: 5px;">Total</td>
                      <td style="border: 1px solid black; padding: 5px; text-align: right;">#TOTAL#</td>
                    </tr>
                  </tfoot>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 1px solid black; padding: 5px;">
                <strong>Amount in Words:</strong> #INWORDS#
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 1px solid black; padding: 5px;">
                <strong>Due Date:</strong> #DUEDATE#
              </td>
            </tr>
          </tbody>
        </table>
      </figure>
    `
  },
  'fee-receipt': {
    code: 'FEE_RECEIPT',
    name: 'Fee Receipt',
    keywords: [
      '#RECEIPTNO#',
      '#DATE#',
      '#STUDENTNAME#',
      '#CLASS#',
      '#SECTION#',
      '#PAYMENTMODE#',
      '#FEEHEAD#',
      '#AMOUNT#',
      '#TOTAL#',
      '#INWORDS#',
      '#COLLECTEDBY#',
    ],
    defaultTemplate: `
      <figure class="table">
        <table style="width:100%; border-collapse: collapse; border: 1px solid black;">
          <thead>
            <tr>
              <th colspan="2" style="text-align: center; border: 1px solid black; padding: 10px;">
                <h3>SCHOOL NAME</h3>
                <p>School Address, City</p>
                <h4>FEE RECEIPT</h4>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid black; padding: 5px;"><strong>Receipt No:</strong> #RECEIPTNO#</td>
              <td style="border: 1px solid black; padding: 5px;"><strong>Date:</strong> #DATE#</td>
            </tr>
            <tr>
              <td style="border: 1px solid black; padding: 5px;"><strong>Student Name:</strong> #STUDENTNAME#</td>
              <td style="border: 1px solid black; padding: 5px;"><strong>Class/Section:</strong> #CLASS# - #SECTION#</td>
            </tr>
            <tr>
              <td colspan="2" style="border: 1px solid black; padding: 5px;"><strong>Payment Mode:</strong> #PAYMENTMODE#</td>
            </tr>
            <tr>
              <td colspan="2" style="border: 1px solid black; padding: 0;">
                <table style="width: 100%; border-collapse: collapse;">
                  <thead>
                    <tr style="background-color: #f0f0f0;">
                      <th style="border: 1px solid black; padding: 5px;">Fee Head</th>
                      <th style="border: 1px solid black; padding: 5px; text-align: right;">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Repeatable fee row -->
                    <tr>
                      <td style="border: 1px solid black; padding: 5px;">#FEEHEAD#</td>
                      <td style="border: 1px solid black; padding: 5px; text-align: right;">#AMOUNT#</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr style="font-weight: bold;">
                      <td style="border: 1px solid black; padding: 5px;">Total Paid</td>
                      <td style="border: 1px solid black; padding: 5px; text-align: right;">#TOTAL#</td>
                    </tr>
                  </tfoot>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 1px solid black; padding: 5px;">
                <strong>Amount in Words:</strong> #INWORDS#
              </td>
            </tr>
            <tr>
              <td colspan="2" style="border: 1px solid black; padding: 5px; text-align: right; font-size: 0.8em;">
                Collected By: #COLLECTEDBY#
              </td>
            </tr>
          </tbody>
        </table>
      </figure>
    `
  },
  'fee-certificate': {
    code: 'FEE_CERTIFICATE',
    name: 'Fee Certificate',
    keywords: [
      '#STUDENTNAME#',
      '#CLASS#',
      '#SESSION#',
      '#FEEAMOUNT#',
      '#INWORDS#',
      '#DATE#',
    ],
    defaultTemplate: `
      <div style="border: 2px solid black; padding: 20px; text-align: center; font-family: serif;">
        <h1>SCHOOL NAME</h1>
        <p>School Address, City</p>
        <hr />
        <h2>TO WHOMSOEVER IT MAY CONCERN</h2>
        <br />
        <p style="text-align: justify; line-height: 1.6;">
          This is to certify that <strong>#STUDENTNAME#</strong>, a student of Class <strong>#CLASS#</strong>, 
          has paid a total fee of <strong>#FEEAMOUNT#</strong> (In words: <strong>#INWORDS#</strong>) 
          for the academic session <strong>#SESSION#</strong>.
        </p>
        <br />
        <p style="text-align: justify; line-height: 1.6;">
          This certificate is issued on <strong>#DATE#</strong> upon request for income tax/reimbursement purposes.
        </p>
        <br />
        <br />
        <div style="display: flex; justify-content: space-between; margin-top: 50px;">
          <div>
            <p><strong>Date:</strong> #DATE#</p>
          </div>
          <div>
            <p><strong>Authorized Signatory</strong></p>
          </div>
        </div>
      </div>
    `
  },
  'academic-certificate': {
    code: 'ACADEMIC_CERTIFICATE',
    name: 'Academic Certificate',
    keywords: [
      '#STUDENTNAME#',
      '#FATHERNAME#',
      '#MOTHERNAME#',
      '#CLASS#',
      '#SESSION#',
      '#DOB#',
      '#RESULT#',
      '#CONDUCT#',
      '#DATE#',
    ],
    defaultTemplate: `
      <div style="border: 5px double #000; padding: 40px; text-align: center; font-family: 'Times New Roman', serif;">
        <h1 style="font-size: 36px; margin-bottom: 10px;">SCHOOL NAME</h1>
        <p style="font-size: 18px; margin-top: 0;">School Address, City</p>
        
        <h2 style="font-size: 28px; text-decoration: underline; margin-top: 40px; margin-bottom: 40px;">ACADEMIC CERTIFICATE</h2>
        
        <p style="font-size: 18px; line-height: 2; text-align: justify;">
          This is to certify that <strong>#STUDENTNAME#</strong>, 
          Son/Daughter of Mr. <strong>#FATHERNAME#</strong> and Mrs. <strong>#MOTHERNAME#</strong>,
          was a bona fide student of Class <strong>#CLASS#</strong> during the academic session <strong>#SESSION#</strong>.
        </p>
        
        <p style="font-size: 18px; line-height: 2; text-align: justify;">
          His/Her Date of Birth as per school records is <strong>#DOB#</strong>.
          He/She has passed the annual examination with result: <strong>#RESULT#</strong>.
        </p>
        
        <p style="font-size: 18px; line-height: 2; text-align: justify;">
          During his/her stay in the school, his/her conduct was <strong>#CONDUCT#</strong>.
        </p>
        
        <div style="display: flex; justify-content: space-between; margin-top: 80px; font-size: 18px;">
          <div style="text-align: left;">
            <p>Date: #DATE#</p>
            <p>Place: City</p>
          </div>
          <div style="text-align: center;">
            <p>____________________</p>
            <p>Principal</p>
            <p>(Seal & Signature)</p>
          </div>
        </div>
      </div>
    `
  },
  'character-certificate': {
    code: 'CHARACTER_CERTIFICATE',
    name: 'Character Certificate',
    keywords: [
      '#STUDENTNAME#',
      '#FATHERNAME#',
      '#CLASS#',
      '#SESSION#',
      '#CHARACTER#',
      '#DATE#',
    ],
    defaultTemplate: `
      <div style="border: 2px solid #000; padding: 30px; text-align: center; font-family: serif;">
        <h1>SCHOOL NAME</h1>
        <p>School Address, City</p>
        <hr style="border-top: 1px solid #000; margin: 20px 0;">
        
        <h2>CHARACTER CERTIFICATE</h2>
        
        <p style="text-align: justify; line-height: 2; font-size: 18px; margin-top: 40px;">
          This is to certify that <strong>#STUDENTNAME#</strong>, 
          Son/Daughter of Mr. <strong>#FATHERNAME#</strong>, 
          is/was a bona fide student of this institution studying in Class <strong>#CLASS#</strong> 
          during the academic session <strong>#SESSION#</strong>.
        </p>
        
        <p style="text-align: justify; line-height: 2; font-size: 18px;">
          To the best of my knowledge and belief, he/she bears a <strong>#CHARACTER#</strong> moral character. 
          I wish him/her all success in future endeavors.
        </p>
        
        <div style="display: flex; justify-content: space-between; margin-top: 60px;">
          <div>
            <p><strong>Date:</strong> #DATE#</p>
          </div>
          <div>
            <p><strong>Principal</strong></p>
          </div>
        </div>
      </div>
    `
  },
  'tc-cbse': {
    code: 'TC_CBSE',
    name: 'TC (CBSE Format)',
    keywords: [
      '#STUDENTNAME#',
      '#FATHERNAME#',
      '#DOB#',
      '#ADMISSIONNO#',
      '#LASTCLASS#',
      '#SESSION#',
      '#REASON#',
      '#DATE#',
    ],
    defaultTemplate: `
      <div style="padding: 20px; font-family: Arial, sans-serif;">
        <div style="text-align: center;">
          <h1>SCHOOL NAME</h1>
          <p>CBSE Affiliation No: XXXXXXX | School Code: XXXXX</p>
          <p>School Address, City</p>
          <h2>TRANSFER CERTIFICATE</h2>
        </div>
        
        <table style="width: 100%; border-collapse: collapse; margin-top: 30px; font-size: 16px;">
          <tr>
            <td style="padding: 8px;">1. Name of Student</td>
            <td style="padding: 8px; border-bottom: 1px dotted #000; font-weight: bold;">#STUDENTNAME#</td>
          </tr>
          <tr>
            <td style="padding: 8px;">2. Father's/Guardian's Name</td>
            <td style="padding: 8px; border-bottom: 1px dotted #000; font-weight: bold;">#FATHERNAME#</td>
          </tr>
          <tr>
            <td style="padding: 8px;">3. Date of Birth (in Christian Era)</td>
            <td style="padding: 8px; border-bottom: 1px dotted #000; font-weight: bold;">#DOB#</td>
          </tr>
          <tr>
            <td style="padding: 8px;">4. Admission No.</td>
            <td style="padding: 8px; border-bottom: 1px dotted #000; font-weight: bold;">#ADMISSIONNO#</td>
          </tr>
          <tr>
            <td style="padding: 8px;">5. Class in which the pupil last studied</td>
            <td style="padding: 8px; border-bottom: 1px dotted #000; font-weight: bold;">#LASTCLASS#</td>
          </tr>
          <tr>
            <td style="padding: 8px;">6. School/Board Annual Examination last taken with result</td>
            <td style="padding: 8px; border-bottom: 1px dotted #000; font-weight: bold;">#SESSION# - Passed/Failed</td>
          </tr>
          <tr>
            <td style="padding: 8px;">7. Reasons for leaving the school</td>
            <td style="padding: 8px; border-bottom: 1px dotted #000; font-weight: bold;">#REASON#</td>
          </tr>
          <tr>
            <td style="padding: 8px;">8. Date of issue of certificate</td>
            <td style="padding: 8px; border-bottom: 1px dotted #000; font-weight: bold;">#DATE#</td>
          </tr>
        </table>
        
        <div style="display: flex; justify-content: space-between; margin-top: 80px;">
          <div style="text-align: center;">
            <p>Prepared by</p>
            <p>(Name & Designation)</p>
          </div>
          <div style="text-align: center;">
            <p>Checked by</p>
            <p>(Name & Designation)</p>
          </div>
          <div style="text-align: center;">
            <p>Principal</p>
            <p>(Signature & Seal)</p>
          </div>
        </div>
      </div>
    `
  },
  'tc-rbse': {
    code: 'TC_RBSE',
    name: 'TC (RBSE Format)',
    keywords: [
      '#STUDENTNAME#',
      '#FATHERNAME#',
      '#DOB#',
      '#ADMISSIONNO#',
      '#LASTCLASS#',
      '#SESSION#',
      '#REASON#',
      '#DATE#',
    ],
    defaultTemplate: `
      <div style="padding: 20px; font-family: 'Devanagari', serif;">
        <div style="text-align: center; border: 2px solid #000; padding: 10px;">
          <h1>RAJASTHAN BOARD OF SECONDARY EDUCATION</h1>
          <h2>SCHOOL NAME, CITY</h2>
          <h3>TRANSFER CERTIFICATE / SCHOLAR'S REGISTER RECORD</h3>
        </div>
        
        <div style="margin-top: 30px; font-size: 18px; line-height: 2;">
          <p>
            Certified that <strong>#STUDENTNAME#</strong>, 
            Son/Daughter of <strong>#FATHERNAME#</strong>, 
            Date of Birth <strong>#DOB#</strong>, 
            Scholar No. <strong>#ADMISSIONNO#</strong>, 
            attended this school up to <strong>#DATE#</strong>.
          </p>
          
          <p>
            He/She has paid all dues to the school. 
            He/She was reading in Class <strong>#LASTCLASS#</strong> in the session <strong>#SESSION#</strong>.
          </p>
          
          <p>
            Reason for leaving school: <strong>#REASON#</strong>.
            His/Her character was Good.
          </p>
        </div>
        
        <div style="display: flex; justify-content: space-between; margin-top: 100px;">
          <div style="text-align: center;">
            <p>Class Teacher</p>
          </div>
          <div style="text-align: center;">
            <p>Clerk</p>
          </div>
          <div style="text-align: center;">
            <p>Principal</p>
            <p>(Seal & Signature)</p>
          </div>
        </div>
      </div>
    `
  },
  'student-id-card': {
    code: 'STUDENT_ID',
    name: 'Student ID Card',
    keywords: [
      '#STUDENTNAME#',
      '#SCHOLARNO#',
      '#CLASS#',
      '#SECTION#',
      '#DOB#',
      '#BLOODGROUP#',
      '#PHOTO#',
      '#VALIDUPTO#',
    ],
    defaultTemplate: `
<style>
.landscape-layout {
display:block;
}
.portrait-layout {
display:none;
}
.id-card.portrait .landscape-layout {
display:none;
}
.id-card.portrait .portrait-layout {
display:block;
}
</style>

<!-- LANDSCAPE CARD -->
<div class="landscape-layout">
<div style="position:absolute; top:10px; left:0; width:100%; text-align:center; font-weight:bold; font-size:16px;">
YOUR SCHOOL NAME
</div>
<div style="position:absolute; top:30px; left:0; width:100%; text-align:center; font-size:10px;">
Your School Address, City
</div>
<div style="position:absolute; top:60px; left:15px;">
#PHOTO#
</div>
<div style="position:absolute; top:60px; left:120px; font-size:11px; line-height:1.6;">
<div><strong>Name:</strong> #STUDENTNAME#</div>
<div><strong>Scholar No:</strong> #SCHOLARNO#</div>
<div><strong>Class:</strong> #CLASS# - #SECTION#</div>
<div><strong>DOB:</strong> #DOB#</div>
<div><strong>Valid Upto:</strong> #VALIDUPTO#</div>
</div>
<div style="position:absolute; bottom:15px; right:30px;">
<div style="border-top:1px solid #333; width:80px; text-align:center; font-size:10px;">Principal</div>
</div>
</div>

<!-- PORTRAIT CARD -->
<div class="portrait-layout">
<div style="position:absolute; top:10px; left:0; width:100%; text-align:center; font-weight:bold; font-size:14px;">
YOUR SCHOOL NAME
</div>
<div style="position:absolute; top:28px; left:0; width:100%; text-align:center; font-size:9px;">
Your School Address, City
</div>
<div style="position:absolute; top:55px; left:50%; transform:translateX(-50%);">
#PHOTO#
</div>
<div style="position:absolute; top:170px; left:20px; font-size:11px; line-height:1.6; width:170px;">
<div><strong>Name:</strong> #STUDENTNAME#</div>
<div><strong>Scholar No:</strong> #SCHOLARNO#</div>
<div><strong>Class:</strong> #CLASS# - #SECTION#</div>
<div><strong>DOB:</strong> #DOB#</div>
<div><strong>Valid Upto:</strong> #VALIDUPTO#</div>
</div>
<div style="position:absolute; bottom:30px; left:50%; transform:translateX(-50%);">
<div style="border-top:1px solid #333; width:90px; text-align:center; font-size:10px;">Principal</div>
</div>
</div>
`,
  },
  'employee-id-card': {
    code: 'EMPLOYEE_ID',
    name: 'Employee ID Card',
    keywords: [
      '#EMPLOYEENAME#',
      '#EMPLOYEEID#',
      '#DESIGNATION#',
      '#DEPARTMENT#',
      '#PHOTO#',
      '#VALIDUPTO#',
    ],
    defaultTemplate: `
      <div style="width: 323px; height: 204px; border: 1px solid #000; padding: 10px; border-radius: 8px; font-family: Arial, sans-serif; position: relative; background: #fff0f5;">
        <div style="text-align: center; border-bottom: 2px solid #b30056; padding-bottom: 5px; margin-bottom: 10px;">
          <h3 style="margin: 0; color: #b30056; font-size: 14px;">SCHOOL NAME</h3>
          <p style="margin: 0; font-size: 10px;">School Address, City</p>
        </div>
        <div style="display: flex;">
          <div style="width: 80px; margin-right: 10px;">
            <img src="#PHOTO#" alt="Photo" style="width: 80px; height: 100px; border: 1px solid #ccc; object-fit: cover;" />
          </div>
          <div style="flex: 1; font-size: 11px; line-height: 1.4;">
            <p style="margin: 2px 0;"><strong>Name:</strong> #EMPLOYEENAME#</p>
            <p style="margin: 2px 0;"><strong>ID:</strong> #EMPLOYEEID#</p>
            <p style="margin: 2px 0;"><strong>Designation:</strong> #DESIGNATION#</p>
            <p style="margin: 2px 0;"><strong>Department:</strong> #DEPARTMENT#</p>
            <p style="margin: 2px 0;"><strong>Valid Upto:</strong> #VALIDUPTO#</p>
          </div>
        </div>
        <div style="position: absolute; bottom: 5px; right: 10px; text-align: right;">
          <p style="margin: 0; font-size: 10px;">Authorized Signatory</p>
        </div>
      </div>
    `,
  },
  'no-dues': {
    code: 'NO_DUES',
    name: 'No Dues Certificate',
    keywords: [
      '#STUDENTNAME#',
      '#CLASS#',
      '#SESSION#',
      '#DATE#',
    ],
    defaultTemplate: `
      <div style="border: 2px solid #000; padding: 30px; text-align: center; font-family: serif;">
        <h1>SCHOOL NAME</h1>
        <p>School Address, City</p>
        <hr style="border-top: 1px solid #000; margin: 20px 0;">
        
        <h2>NO DUES CERTIFICATE</h2>
        
        <p style="text-align: justify; line-height: 2; font-size: 18px; margin-top: 40px;">
          This is to certify that <strong>#STUDENTNAME#</strong>, 
          student of Class <strong>#CLASS#</strong> for the academic session <strong>#SESSION#</strong>, 
          has cleared all dues against him/her.
        </p>
        
        <p style="text-align: justify; line-height: 2; font-size: 18px;">
          There are no outstanding payments pending as of <strong>#DATE#</strong>.
        </p>
        
        <div style="display: flex; justify-content: space-between; margin-top: 60px;">
          <div>
            <p><strong>Date:</strong> #DATE#</p>
          </div>
          <div>
            <p><strong>Accountant</strong></p>
          </div>
          <div>
            <p><strong>Principal</strong></p>
          </div>
        </div>
      </div>
    `,
  },
  'sr-register': {
    code: 'SR_REGISTER',
    name: 'Student Register (SR)',
    keywords: [
      '#SCHOLARNO#',
      '#STUDENTNAME#',
      '#FATHERNAME#',
      '#DOB#',
      '#CASTE#',
      '#CATEGORY#',
      '#ADMISSIONDATE#',
      '#REMOVALDATE#',
      '#REASON#',
      '#RESULT#',
    ],
    defaultTemplate: `
      <div style="width: 100%; overflow-x: auto;">
        <h2 style="text-align: center;">SCHOLAR'S REGISTER</h2>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid black; font-size: 12px;">
          <thead>
            <tr style="background-color: #f2f2f2;">
              <th style="border: 1px solid black; padding: 5px;">Scholar No</th>
              <th style="border: 1px solid black; padding: 5px;">Student Name</th>
              <th style="border: 1px solid black; padding: 5px;">Father's Name</th>
              <th style="border: 1px solid black; padding: 5px;">DOB</th>
              <th style="border: 1px solid black; padding: 5px;">Caste</th>
              <th style="border: 1px solid black; padding: 5px;">Category</th>
              <th style="border: 1px solid black; padding: 5px;">Adm. Date</th>
              <th style="border: 1px solid black; padding: 5px;">Removal Date</th>
              <th style="border: 1px solid black; padding: 5px;">Reason</th>
              <th style="border: 1px solid black; padding: 5px;">Result</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid black; padding: 5px;">#SCHOLARNO#</td>
              <td style="border: 1px solid black; padding: 5px;">#STUDENTNAME#</td>
              <td style="border: 1px solid black; padding: 5px;">#FATHERNAME#</td>
              <td style="border: 1px solid black; padding: 5px;">#DOB#</td>
              <td style="border: 1px solid black; padding: 5px;">#CASTE#</td>
              <td style="border: 1px solid black; padding: 5px;">#CATEGORY#</td>
              <td style="border: 1px solid black; padding: 5px;">#ADMISSIONDATE#</td>
              <td style="border: 1px solid black; padding: 5px;">#REMOVALDATE#</td>
              <td style="border: 1px solid black; padding: 5px;">#REASON#</td>
              <td style="border: 1px solid black; padding: 5px;">#RESULT#</td>
            </tr>
          </tbody>
        </table>
      </div>
    `,
  },
};
